import { createDecorator } from 'vue-class-component';

/**
 * Custom mutation decorator, used to map vuex mutations
 * to component methods.
 * 
 * @Mutation
 * componentMethod(arg: any) {
 *   return arg;
 * }
 * 
 * The name of the method should be the exact same name as the
 * mutation, and the return value of the method will be used as
 * the mutation payload. It is possible to defined an empty method
 * to simply execute a mutation that has no payload.
 */

const Mutation = createDecorator((componentOptions, key) => {
  
  // Ensure the component has a methods object
  if (!componentOptions.methods) componentOptions.methods = {};

  // Duplicate the original method
  const originalMethod: any = componentOptions.methods[key];

  // Overwrite method
  componentOptions.methods[key] = function() {

    // Call original method as intended and store the result
    const payload = originalMethod.apply(this, arguments);

    // Commit the method result as payload using method name as commit type
    (this as any).$store.commit(key, payload);
  }
});

export default Mutation;
